import Scrollbar from 'smooth-scrollbar';

export default {
  install: (app) => {
    app.config.globalProperties.$Scrollbar = Scrollbar;
  },
};
